import type { ISEOProps } from "../types/core";

export const LikedPostsPageSEO: ISEOProps = {
  title: "Liked Posts - Sugar Cribs",
  description:
    "View all your liked posts on Sugar Cribs. Discover and revisit your favorite content from creators.",
};
